window.setHtml = function (html, id) {
    document.querySelector("#" + id).innerHTML = html;
}